import { Routes } from '@angular/router';

import {EspaceCandidatComponent} from './espaceCandidat.component';
import {UserRouteAccessService} from '../../shared/auth/user-route-access-service';

export const espaceCandidatRoute: Routes = [
  {
    path: 'espaceCandidat',
    component: EspaceCandidatComponent,
    data: {
        authorities: ['ROLE_USER'],
        pageTitle: 'cadensApp.candidature.home.title'
    },
    canActivate: [UserRouteAccessService]
  }
];



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/espaceCandidat/espaceCandidat.route.ts